export const useGetDiscountsInMemoryCacheClient = () => {
  return {
    setCache: async () => void 0,
    validateInMemoryData: async () => void 0,
  };
};
